<template>
<div class="hit-and-blow">
  <h2>Hit and Blow</h2>

  <table class="centerTable">
    <tr v-if="gameStatus != 0">
      <td><button v-on:click="resetGame" ref="resetButton">Reset Game</button></td>
    </tr>

    <tr v-if="gameStatus != 0">
      <td>Elapsed Time: {{ elapsedTime }} [s]</td>
    </tr>

    <tr v-if="gameStatus != 2">
      <td><input v-on:keyup.enter="submitGuess" v-model="guess" placeholder="Input 4 unique numbers" ref="guessInput"> <button v-on:click="submitGuess">Submit Guess</button></td>
    </tr>

    <tr v-if="gameStatus != 0">
      <td v-if="gameStatus != 2">Best Guess: {{ bestGuess.number }} , {{ bestGuess.score }}</td>
    </tr>

    <tr v-if="gameStatus != 0">
      <td>Guess Count: {{ guessCount }}</td>
    </tr>
  </table>

  <Guesses v-if="gameStatus != 0" v-bind:guesses="guesses" />

</div>
</template>

<script>
import Vue from 'vue'
import VueConfetti from 'vue-confetti'
import Guesses from './Guesses.vue'

Vue.use(VueConfetti)

export default {
  name: 'hit-and-blow',
  components: {
    Guesses
  },
  data: function() {
    return {
      gameStatus: 0, // init: 0, live: 1, pause: 2
      answer: '',
      startTime: 0,
      elapsedTime: 0,
      guessCount: 0,
      bestGuess: {
        number: 0,
        aCount: 0,
        bCount: 0,
        score: ''
      },
      guess: '',
      guesses: []
    }
  },
  created: function() {
    this.startTime = new Date().getTime()
    this.elapsedTime = (new Date().getTime()) - this.startTime
    const self = this;
    this.answer = self.generateAnswerCandidate()
    setInterval(function() {
      self.updateTimer()
    }, 100)
    this.$nextTick(() => this.$refs.guessInput.focus())
  },
  beforeDestroy() {
    this.$confetti.stop()
  },
  methods: {
    resetTimer: function() {
      this.startTime = new Date().getTime()
      this.elapsedTime = (new Date().getTime()) - this.startTime
    },
    resetGame: function() {
      this.$confetti.stop()
      this.gameStatus = 0
      this.resetTimer()
      this.answer = this.generateAnswerCandidate()
      this.guessCount = 0
      this.bestGuess = {
        number: 0,
        aCount: 0,
        bCount: 0,
        score: ''
      }
      this.guess = ''
      this.guesses = []
      this.$nextTick(() => this.$refs.guessInput.focus())
    },
    submitGuess: function() {
      if (this.guess == this.answer) {
        alert('You win!')
        this.$confetti.start({
          shape: 'heart'
        })
        document.getElementById('confetti-canvas').setAttribute('style', document.getElementById('confetti-canvas').getAttribute('style') + 'z-index: -100;')
        if (this.gameStatus == 0) {
          this.resetTimer()
        }
        this.gameStatus = 2
        this.$nextTick(() => this.$refs.resetButton.focus())
      }
      if (this.guess == '') {
        alert('No number was input')
        this.guess = ''
      } else if (this.guess.length != 4) {
        alert('Only 4 digit numbers are allowed')
        this.guess = ''
      } else if (this.nonNumeric(this.guess)) {
        alert('Only digits 0-9 are allowed')
        this.guess = ''
      } else if (this.containsDuplicateDigits(this.guess)) {
        alert('Please input 4 unique numbers')
        this.guess = ''
      } else {
        if (this.alreadyGuessed(this.guess)) {
          alert('This number sequence has already been guessed')
          this.guess = ''
        } else {
          if (this.gameStatus == 0) {
            this.resetTimer()
            this.gameStatus = 1
          }
          var newGuess = this.processGuess(this.guess)
          if (this.bestGuess.number == 0) {
            this.bestGuess = newGuess
          } else if (this.isNewHighScore(newGuess)) {
            this.bestGuess = newGuess
          }
          this.guesses.unshift(newGuess)
          this.guessCount++;
          this.guess = ''
          this.$nextTick(() => this.$refs.guessInput.focus())
        }
      }
    },
    alreadyGuessed: function(newGuess) {
      for (let guess of this.guesses) {
        if (guess.number == newGuess) {
          return true
        }
      }
      return false
    },
    nonNumeric: function(number) {
      return (/\D/).test(number)
    },
    containsDuplicateDigits: function(number) {
      return (/([0-9]).*?\1/).test(number)
    },
    processGuess: function(guess) {
      var aCount = 0
      var bCount = 0

      for (var i = 0; i < guess.length; i++) {
        for (var j = 0; j < guess.length; j++) {
          if (i == j) {
            continue
          }
          if (guess.charAt(i) == this.answer.charAt(j)) {
            bCount++
          }
        }
      }

      for (var k = 0; k < guess.length; k++) {
        if (guess.charAt(k) == this.answer.charAt(k)) {
          aCount++
        }
      }

      var score = ''
      if (aCount == 0 && bCount == 0) {
        score = '0A0B'
      }
      if (aCount == 0 && bCount != 0) {
        score = bCount + 'B'
      }
      if (aCount != 0 && bCount == 0) {
        score = aCount + 'A'
      }
      if (aCount != 0 && bCount != 0) {
        score = aCount + 'A' + bCount + 'B'
      }
      return {
        isWinner: (score == '4A') ? true : false,
        isLoser: (score == '0A0B') ? true : false,
        number: guess,
        aCount: aCount,
        bCount: bCount,
        score: score
      }
    },
    isNewHighScore: function(guess) {
      if (guess.aCount > this.bestGuess.aCount) {
        return true
      } else if (guess.aCount == this.bestGuess.aCount) {
        if (guess.bCount > this.bestGuess.bCount) {
          return true
        }
      }
      return false
    },
    generateAnswerCandidate: function() {
      var randomNumber = Math.floor(Math.random() * (9999 + 1));
      randomNumber = this.zeroPadAnswerCandidate(randomNumber)
      var randomNumberString = randomNumber.toString()
      while (this.containsDuplicateDigits(randomNumberString)) {
        randomNumber = Math.floor(Math.random() * (9999 + 1));
        randomNumber = this.zeroPadAnswerCandidate(randomNumber)
        randomNumberString = randomNumber.toString()
      }
      return randomNumberString
    },
    zeroPadAnswerCandidate: function(number) {
      if (number <= 9999) {
        return ("000" + number).slice(-4)
      }
    },
    updateTimer: function() {
      if (this.gameStatus == 1) {
        this.elapsedTime = (((new Date().getTime()) - this.startTime) / 1000).toFixed(1)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hit-and-blow {
  height: 100%;
  overflow: auto;
  max-width: 550px;
  background: rgba(255, 255, 255, 0.9);
  margin: auto;
  box-shadow: 20px 0px 50px grey, -20px 0px 50px grey;
  z-index: -2;
}

::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

h1,
h2 {
  padding-top: 20px;
  font-weight: normal;
}

table {
  margin-left: auto;
  margin-right: auto;
  border-collapse: collapse;
}

.centerTable th,
.centerTable td {
  text-align: center;
  border-bottom: 0px;
}

th,
td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.centerTable tr:hover {
  background-color: #FFFFFF;
}

tr:hover {
  background-color: #F5F5F5;
}
</style>
